import axios from "axios";
import store from "@/store";
import { Auth } from 'aws-amplify';

async function getJwtToken() {
  const session = await Auth.currentSession();
  const token = session.getAccessToken();
  console.log(token.getJwtToken())
  return token.getJwtToken()
}

axios.interceptors.request.use(async function (config) {
  store.dispatch("app/startRequest");
  console.log('Request:', config);

  // avoid attach auth header
  // TODO: notification.json(request to s3 directly would
  // also be needed to attach auth header)
  if (!config.url.endsWith('/notifications.json')) {
    config.headers.common['Authorization'] = await getJwtToken();
  }

  return config;
}, function (error) {
  console.log('Request err:', error);
  store.dispatch("app/endRequest");
  return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  console.log('Response:', response);
  store.dispatch("app/endRequest");
  return response;
}, function (error) {
  console.log('Response err:', error);
  store.dispatch("app/endRequest");
  return Promise.reject(error);
});